import React from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { RubricsList } from "~/api/types/RubricsList"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { Subscription as CommonSubscription } from "~/components/SubscriptionMagazine/components/Subscription/Subscription"
import { Wrapper } from "~/components/Wrapper/Wrapper"

import styles from "./index.module.css"

const excludeRubrics = ["1", "2", "41", "42", "43"]

export const Subscription: React.FC = () => {
  const { t } = useTranslation()
  const categoriesList = useApiContext("/rubrics/list")

  if (!categoriesList || categoriesList.length === 0) {
    return null
  }

  const reducedCategoriesList = categoriesList
    .reduce((prev: RubricsList, curr) => {
      const currentId = curr.id
      const isCurrentId = prev.find((el) => el.id === currentId)

      if (!isCurrentId && !excludeRubrics.includes(currentId)) {
        const cleanedName = curr.name.replace("Закупки - ", "")
        prev.push({ ...curr, name: cleanedName })
      }

      return prev
    }, [])
    .sort((a, b) => (a.name > b.name ? 1 : -1))

  return (
    <Wrapper>
      <div className="container">
        <div className={styles.Wrapper}>
          <div className={styles.TitleWrapper}>
            <Heading as="h2" className={styles.Title} like="h1">
              <Raw html={t("procurements.Subscribtion.Title")} />
            </Heading>

            <p>
              <Raw html={t("procurements.Subscribtion.Text")} />
            </p>
          </div>

          <div className={styles.DescriptionWrapper}>
            <CommonSubscription categoriesList={reducedCategoriesList} returnValuesType={"code"} />
          </div>
        </div>
      </div>
    </Wrapper>
  )
}
